import Tab2 from "../list/features/Tab2";
import {useState} from "react";
import {
    SalesRevenueByCompanyAllMapType,
    SalesRevenueViewInfoElementType,
    SalesSearchParamType
} from "../list/interface";
import {salesRevenueByCompanyAllMapInit, salesSearchParamInit} from "../list/state";
import {useReadRevenueTableSetting} from "../column/hooks/useReadRevenueTableSetting";
import {useForm, useWatch} from "react-hook-form";

export default function SalesExpected() {
    const [searchParam, setSearchParam] = useState<SalesSearchParamType>(salesSearchParamInit);

    const {data: hiddenColumnApiData} = useReadRevenueTableSetting()

    const {
        register,
        handleSubmit,
        getValues,
        setValue,
        watch,
        reset,
        control
    } = useForm({
        defaultValues: salesRevenueByCompanyAllMapInit
    });

    const editData = {
        ...salesRevenueByCompanyAllMapInit,
        ...useWatch<SalesRevenueByCompanyAllMapType>({control}),
    } as SalesRevenueByCompanyAllMapType

    const hiddenColumnData: SalesRevenueViewInfoElementType[] = hiddenColumnApiData?.revenueViewInfoVOList ?? []

    return <Tab2 searchParam={searchParam}
                 dataList={editData.searchAllRevenueResList}
                 hiddenColumnData={hiddenColumnData}
                 monthView={"expected"}
                 isEdit={true}
                 editData={editData}
                 register={register}
                 setValue={setValue}
                 control={control}/>
}